import React from 'react';
import { SettingsCoordinatorAction } from './SettingsCoordinatorActions';

export const SectionNameContext = React.createContext<string>(null);
SectionNameContext.displayName = 'SectionNameContext';

export const SettingsCoordinatorContext = React.createContext<React.Dispatch<SettingsCoordinatorAction>>(null);
SettingsCoordinatorContext.displayName = 'SettingsCoordinatorContext';
